export var IGlobalGuide;
(function (IGlobalGuide) {
    let TipType;
    (function (TipType) {
        TipType["BIG_DATA1"] = "BIG_DATA1";
        TipType["BIG_DATA2"] = "BIG_DATA2";
        TipType["BIG_DATA3"] = "BIG_DATA3";
        TipType["BIG_DATA4"] = "BIG_DATA4";
        TipType["MAIL_MARKETING"] = "MAIL_MARKETING";
        TipType["CRM_CUSTOMER"] = "CRM_CUSTOMER";
        TipType["CRM_LEAD"] = "CRM_LEAD";
        TipType["DEFAULT_TIP"] = "DEFAULT_TIP";
    })(TipType = IGlobalGuide.TipType || (IGlobalGuide.TipType = {}));
    let ModuleType;
    (function (ModuleType) {
        ModuleType["BIG_DATA"] = "BIG_DATA";
        ModuleType["MAIL_MARKETING"] = "MAIL_MARKETING";
        ModuleType["CRM_CUSTOMER"] = "CRM_CUSTOMER";
        ModuleType["CRM_LEAD"] = "CRM_LEAD";
        ModuleType["SMART_SEARCH"] = "SMART_SEARCH";
        ModuleType["DEFAULT"] = "DEFAULT";
    })(ModuleType = IGlobalGuide.ModuleType || (IGlobalGuide.ModuleType = {}));
    let VideoType;
    (function (VideoType) {
        VideoType["SIMPLE"] = "SIMPLE";
        VideoType["COVER"] = "COVER";
    })(VideoType = IGlobalGuide.VideoType || (IGlobalGuide.VideoType = {}));
})(IGlobalGuide || (IGlobalGuide = {}));
